import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { LoginService } from './login.service';

@Injectable({
  providedIn: 'root'
})
export class SecurityService {

  constructor(private loginService: LoginService) { }

  public async userHasApplication(applicationName: string): Promise<boolean> {
    const currentUser = await this.loginService.isLoggedIn();
    if (currentUser) {
      const applications = await this.loginService.getUserApplications();
      return _.find(applications, a => a.route.includes(applicationName)) ? true : false;
    } else {
      return false;
    }
  }

  public userHasPermission(permissionName: string): boolean {
    return this.loginService.hasPermission(permissionName);
  }

  public async userHasPermissionAsync(permissionName: string): Promise<boolean> {
    const currentUser = await this.loginService.isLoggedIn();
    if (!currentUser) {
      return false;
    }

    if (!this.loginService.tokenClaims) {
      await this.loginService.validateToken(false);
    }

    return this.userHasPermission(permissionName);
  }
}
